import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material';
import { ImportDialogModule } from '@components/import/import-dialog.module';
import { ApplicationSwitcherModule } from '@core/application-switcher/application-switcher.module';
import { DialogModule } from '@core/dialog/dialog.module';
import { EmpyreanLoaderModule } from '@core/empyrean-loader/empyrean-loader.module';
import { KendoModule } from '@core/kendo/kendo.module';
import { SharedModule } from '@core/shared.module';
import { ToasterModule } from 'angular2-toaster';
import { HeaderComponent } from './header.component';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    SharedModule,
    ToasterModule,
    KendoModule,
    MatTooltipModule,
    EmpyreanLoaderModule,
    ApplicationSwitcherModule,
    ReactiveFormsModule,
    DialogModule,
    ImportDialogModule
  ],
  exports: [HeaderComponent]
})
export class HeaderModule {}
